(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9537],{

/***/ 31942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CourseInfo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(67804);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(72128);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.esm.js
var popover_esm = __webpack_require__(26835);
// EXTERNAL MODULE: ./features/klass/components/EarlyKlassTooltip/EarlyKlassTooltip.module.scss
var EarlyKlassTooltip_module = __webpack_require__(76973);
var EarlyKlassTooltip_module_default = /*#__PURE__*/__webpack_require__.n(EarlyKlassTooltip_module);
;// CONCATENATED MODULE: ./features/klass/components/EarlyKlassTooltip/index.tsx



var EarlyKlassTooltip = function(param) {
    var wrapperElementRef = param.wrapperElementRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: wrapperElementRef,
        className: "".concat((EarlyKlassTooltip_module_default()).TooltipMotion),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_esm/* Popover */.J, {
            className: "relative flex w-full justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((EarlyKlassTooltip_module_default()).Tooltip)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: "cursor-default ".concat((EarlyKlassTooltip_module_default()).TooltipArrow),
                    width: "20",
                    height: "12",
                    viewBox: "0 0 14 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.26795 0.999997C6.03775 -0.333336 7.96225 -0.333333 8.73205 1L13.0622 8.5C13.832 9.83334 12.8697 11.5 11.3301 11.5H2.66987C1.13027 11.5 0.168022 9.83333 0.937822 8.5L5.26795 0.999997Z",
                        fill: "#262626"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                    static: true,
                    className: "absolute z-10 cursor-default ".concat((EarlyKlassTooltip_module_default()).Tooltip),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-[270px] items-center justify-center rounded-full bg-gray-800 py-1 text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-xs",
                            children: [
                                "지금 사전알림 신청하면",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-semibold text-primary-normal",
                                    children: "IT 직무 취업 가이드북"
                                }),
                                " 증정"
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_EarlyKlassTooltip = (EarlyKlassTooltip);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./mocks/kdt.ts
var kdt = __webpack_require__(96800);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./features/apply/hooks/useCountDown.tsx
var useCountDown = __webpack_require__(28777);
;// CONCATENATED MODULE: ./components/KlassTimer/BasicTimer.tsx


var BasicTimer = function(param) {
    var expiryTimestamp = param.expiryTimestamp;
    var ref = (0,useCountDown/* useCountDown */.h)(expiryTimestamp), format = ref.format, timeUnit = ref.timeUnit, isLeftApplyDurationThreeDays = ref.isLeftApplyDurationThreeDays, isLeftApplyDurationSevenDays = ref.isLeftApplyDurationSevenDays;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-4 hidden rounded-lg border border-gray-300 ".concat(isLeftApplyDurationSevenDays ? "lg:block" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-4 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm text-gray-500",
                    children: "지원 마감까지"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-1 flex justify-center space-x-1.5 font-semibold ".concat(isLeftApplyDurationThreeDays ? "text-red-500" : "text-gray-500"),
                    children: format.map(function(time, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rounded bg-gray-100 px-2 py-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    time,
                                    timeUnit[idx]
                                ]
                            })
                        }, "timeFormat_".concat(idx));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm text-gray-500",
                    children: "남았습니다."
                })
            ]
        })
    });
};
/* harmony default export */ var KlassTimer_BasicTimer = (BasicTimer);

;// CONCATENATED MODULE: ./components/KlassTimer/MobileTimer.tsx


var MobileTimer = function(param) {
    var expiryTimestamp = param.expiryTimestamp;
    var ref = (0,useCountDown/* useCountDown */.h)(expiryTimestamp), format = ref.format, timeUnit = ref.timeUnit, isLeftApplyDurationThreeDays = ref.isLeftApplyDurationThreeDays, isLeftApplyDurationSevenDays = ref.isLeftApplyDurationSevenDays;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "".concat(isLeftApplyDurationSevenDays ? "block" : "hidden", " mr-4 flex flex-col md:flex-row md:items-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "text-xs font-medium md:text-sm",
                children: "지원 마감까지"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 md:ml-3 md:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center space-x-1.5 text-xs md:text-sm ".concat(isLeftApplyDurationThreeDays ? "text-red-500" : "text-gray-500"),
                        children: format.map(function(time, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rounded bg-gray-100 px-2 py-0.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        time,
                                        timeUnit[idx]
                                    ]
                                })
                            }, "timeFormat_".concat(idx));
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var KlassTimer_MobileTimer = (MobileTimer);

// EXTERNAL MODULE: ./components/CourseInfo/ActionButton.tsx
var ActionButton = __webpack_require__(95112);
// EXTERNAL MODULE: ./components/CourseInfo/KlassInfoHeader.tsx + 2 modules
var KlassInfoHeader = __webpack_require__(94501);
// EXTERNAL MODULE: ./components/CourseInfo/KlassInfoSection.tsx
var KlassInfoSection = __webpack_require__(91251);
;// CONCATENATED MODULE: ./components/CourseInfo/index.tsx















dayjs_min_default().extend((isBetween_default()));
var CourseInfo = function(param) {
    var course = param.course, isMobile = param.isMobile, submitType = param.submitType, status = param.status, applyPeriodList = param.applyPeriodList, isDelayCourse = param.isDelayCourse, expiryTimestamp = param.expiryTimestamp, isSigned = param.isSigned, isSimplifyKDT = param.isSimplifyKDT;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var id = course.id, title = course.title, price = course.price, shareUrl = course.shareUrl, panelText = course.panelText, promotion = course.promotion, promotionPrice = course.promotionPrice, courseType = course.courseType, startedAt = course.startedAt, applyStartedAt = course.applyStartedAt, applyEndedAt = course.applyEndedAt, imageM = course.imageM;
    var tooltipContainerRef = (0,react.useRef)(null);
    var curPrice = price.toLocaleString();
    var isOnDemand = (0,react.useMemo)(function() {
        return courseType === "ondemand";
    }, [
        courseType
    ]);
    var isWorker = (0,react.useMemo)(function() {
        return courseType === "worker";
    }, [
        courseType
    ]);
    var isKDT = (0,react.useMemo)(function() {
        return courseType === "kdt" || courseType === "kdt_plus" || courseType === "kdt_startup";
    }, [
        courseType
    ]);
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), scroll = ref23[0];
    var ref24 = (0,react.useState)(null), openAddition = ref24[0], setOpenAddition = ref24[1];
    var handleItemClick = function(itemId) {
        setOpenAddition(itemId === openAddition ? null : itemId);
    };
    var isPromotionActive = (0,react.useMemo)(function() {
        return promotion !== null && ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionRate) > 0 || (promotion === null || promotion === void 0 ? void 0 : promotion.promotionAmount) > 0);
    }, [
        promotion
    ]);
    var promotionRate = (0,react.useMemo)(function() {
        if (promotion === null || promotionPrice === null) return 0;
        if (promotion.promotionType === "rate") return promotion.promotionRate;
        else if (promotion.promotionType === "amount") {
            var rate = promotion.promotionAmount / price;
            return Math.floor((rate > 1 ? 1 : rate) * 100);
        }
        return 0;
    }, [
        price,
        promotion,
        promotionPrice
    ]);
    var amountPerInstallment = (0,react.useMemo)(function() {
        if (isPromotionActive && promotionPrice !== null && promotionPrice > 0) return (promotionPrice / 5).toLocaleString();
        else return (price / 5).toLocaleString();
    }, [
        isPromotionActive,
        price,
        promotionPrice
    ]);
    var curStatus = isSimplifyKDT ? {
        early: "early",
        assignment: "assignment",
        assignmentReview: "assignmentReview",
        participation: dayjs_min_default()().isBefore(startedAt) ? "participation" : "ing",
        participationReview: dayjs_min_default()().isBefore(startedAt) ? "participationReview" : "ing",
        ing: "ing",
        end: "end"
    } : {
        apply: "apply",
        assignment: "assignment",
        participation: dayjs_min_default()().isBefore(startedAt) ? "participation" : "ing"
    };
    var nextStatus = isSimplifyKDT ? {
        assignmentReview: "participation",
        assignment: "participation"
    } : {
        apply: "assignment",
        assignment: "participation"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block border-b lg:hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "block lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-4 pb-6 pt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                                isMobile: true,
                                klassId: id,
                                title: title,
                                panelText: panelText,
                                shareUrl: shareUrl,
                                imgUrl: imageM
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoSection/* default */.Z, {
                                        course: course,
                                        isKDT: isKDT,
                                        isSimplifyKDT: isSimplifyKDT,
                                        isDelayCourse: isDelayCourse,
                                        isPreNoticeStatus: (ref = submitType[status]) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.includes("사전알림 신청"),
                                        applyStatus: status,
                                        applyPeriodList: applyPeriodList
                                    }),
                                    !isKDT && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "my-4 border-t"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex text-sm text-gray-500",
                                                    children: ~~price !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: isPromotionActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "line-through",
                                                                    children: [
                                                                        curPrice,
                                                                        "원"
                                                                    ]
                                                                }),
                                                                !isOnDemand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "\xa0/\xa0",
                                                                        promotionPrice !== null && promotionPrice > 0 ? promotionPrice.toLocaleString() : 0,
                                                                        "원"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : !isOnDemand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                curPrice,
                                                                "원"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex items-baseline space-x-1",
                                                        children: isPromotionActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-xl font-bold text-primary-normal",
                                                                    children: [
                                                                        promotionRate > 0 && promotionRate,
                                                                        "%"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-xl font-semibold",
                                                                    children: [
                                                                        promotionPrice !== null && promotionPrice > 0 && (promotionPrice === null || promotionPrice === void 0 ? void 0 : promotionPrice.toLocaleString()),
                                                                        "원"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-xl font-semibold leading-tight",
                                                            children: ~~price === 0 ? "무료" : "".concat(curPrice, "원")
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-4 flex flex-col gap-y-2 lg:mt-5",
                    children: (ref2 = kdt/* AdditionalList */.jh[courseType]) === null || ref2 === void 0 ? void 0 : ref2.map(function(addition) {
                        var isOpen = openAddition === addition.id;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "cursor-pointer rounded-lg bg-gray-50 px-4 py-3 last-of-type:mb-6",
                            onClick: function() {
                                return handleItemClick(addition.id);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex h-6 w-6 items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: addition.icon,
                                                        alt: addition.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-sm font-bold",
                                                    children: [
                                                        addition.boldTitle,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-1 inline-block font-normal",
                                                            children: addition.title
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                            className: "".concat(isOpen ? "" : "rotate-180 transform", " w-4 text-gray-400")
                                        })
                                    ]
                                }),
                                isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-4 flex flex-col gap-y-1.5",
                                    children: [
                                        addition.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xs font-semibold",
                                            children: addition.summary
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-xs text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: addition.boldDesc
                                                }),
                                                addition.desc
                                            ]
                                        }),
                                        addition.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs text-gray-500",
                                            children: addition.reference
                                        })
                                    ]
                                })
                            ]
                        }, addition.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fixed bottom-0 left-0 z-30 block w-full bg-white shadow-[0px_-1px_4px_0px_rgba(0,0,0,0.05)] lg:hidden",
                    style: {
                        minWidth: 320
                    },
                    children: [
                        isKDT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                ((ref3 = submitType[status]) === null || ref3 === void 0 ? void 0 : ref3.name.includes("완료")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-center border-b py-1.5 text-sm font-normal text-gray-500",
                                    children: [
                                        status !== "participation" ? " ".concat(dayjs_min_default()(applyPeriodList && ((ref4 = applyPeriodList[nextStatus[status]]) === null || ref4 === void 0 ? void 0 : ref4.startedAt)).format("M월 D일"), " ").concat(isSimplifyKDT ? "" : "".concat((ref5 = submitType[status]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.name) === null || ref6 === void 0 ? void 0 : ref6.charAt(0), "차"), " 합격 발표 ") : "".concat(dayjs_min_default()(startedAt).format("M월 D일"), " 훈련이 시작될 "),
                                        "예정입니다."
                                    ]
                                }),
                                !isSigned && dayjs_min_default()().isAfter(applyEndedAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-center border-b py-1.5 text-sm font-normal text-gray-500",
                                    children: "이미 지원한 경우 로그인하여 진행내역을 확인하세요."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-4 py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    (((ref7 = submitType[status]) === null || ref7 === void 0 ? void 0 : ref7.period) === "applying" || isWorker && dayjs_min_default()().isBetween(applyStartedAt, applyEndedAt, undefined, "[)")) && expiryTimestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassTimer_MobileTimer, {
                                        expiryTimestamp: expiryTimestamp
                                    }),
                                    !lodash_default().isEmpty(submitType) && !lodash_default().isEmpty(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            status === "early" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: tooltipContainerRef,
                                                className: "absolute left-1/2 top-1 flex items-center justify-center text-gray-500",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EarlyKlassTooltip, {
                                                    wrapperElementRef: tooltipContainerRef
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                                klassId: id,
                                                disabled: (ref8 = submitType[isKDT ? curStatus[status] : status]) === null || ref8 === void 0 ? void 0 : ref8.disabled,
                                                handler: (ref9 = submitType[isKDT ? curStatus[status] : status]) === null || ref9 === void 0 ? void 0 : ref9.handler,
                                                name: (ref10 = submitType[isKDT ? curStatus[status] : status]) === null || ref10 === void 0 ? void 0 : ref10.name,
                                                isMobile: isMobile
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 pt-5 lg:rounded-lg lg:border lg:border-gray-300 lg:p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                            isMobile: false,
                            klassId: id,
                            title: title,
                            panelText: panelText,
                            shareUrl: shareUrl,
                            imgUrl: imageM
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoSection/* default */.Z, {
                                    course: course,
                                    isKDT: isKDT,
                                    isSimplifyKDT: isSimplifyKDT,
                                    isDelayCourse: isDelayCourse,
                                    isPreNoticeStatus: (ref11 = submitType[status]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.name) === null || ref12 === void 0 ? void 0 : ref12.includes("사전알림 신청"),
                                    applyStatus: status,
                                    applyPeriodList: applyPeriodList
                                }),
                                !isKDT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "my-4 border-gray-300"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex text-sm text-gray-500",
                                                    children: ~~price !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: isPromotionActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "line-through",
                                                                    children: [
                                                                        curPrice,
                                                                        "원"
                                                                    ]
                                                                }),
                                                                !isOnDemand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "\xa0/\xa0",
                                                                        promotionPrice !== null && promotionPrice > 0 ? promotionPrice.toLocaleString() : 0,
                                                                        "원"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : !isOnDemand && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                curPrice,
                                                                "원"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-baseline space-x-1",
                                                    children: isPromotionActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-xl font-bold text-primary-normal",
                                                                children: [
                                                                    promotionRate > 0 && promotionRate,
                                                                    "%"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-xl font-semibold",
                                                                children: [
                                                                    promotionPrice !== null && promotionPrice > 0 && (promotionPrice === null || promotionPrice === void 0 ? void 0 : promotionPrice.toLocaleString()),
                                                                    "원"
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex items-baseline space-x-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-xl font-semibold leading-tight",
                                                            children: ~~price === 0 ? "무료" : "".concat(curPrice, "원")
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        !lodash_default().isEmpty(submitType) && !lodash_default().isEmpty(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(status === "early" ? "relative mt-9" : ""),
                                    children: [
                                        status === "early" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: tooltipContainerRef,
                                            className: "absolute -top-1 left-1/2 flex items-center justify-center text-gray-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EarlyKlassTooltip, {
                                                wrapperElementRef: tooltipContainerRef
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                            klassId: id,
                                            disabled: (ref13 = submitType[isKDT ? curStatus[status] : status]) === null || ref13 === void 0 ? void 0 : ref13.disabled,
                                            handler: (ref14 = submitType[isKDT ? curStatus[status] : status]) === null || ref14 === void 0 ? void 0 : ref14.handler,
                                            name: (ref15 = submitType[isKDT ? curStatus[status] : status]) === null || ref15 === void 0 ? void 0 : ref15.name
                                        })
                                    ]
                                }),
                                isKDT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        ((ref16 = submitType[status]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.name) === null || ref17 === void 0 ? void 0 : ref17.includes("완료")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-2 text-sm font-normal text-gray-500",
                                            children: [
                                                "\xa0∙",
                                                " ",
                                                status !== "participation" ? " ".concat(dayjs_min_default()(applyPeriodList && ((ref18 = applyPeriodList[nextStatus[status]]) === null || ref18 === void 0 ? void 0 : ref18.startedAt)).format("M월 D일"), " ").concat(isSimplifyKDT ? "" : "".concat((ref19 = submitType[status]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.name) === null || ref20 === void 0 ? void 0 : ref20.charAt(0), "차"), " 합격 발표 ") : "".concat(dayjs_min_default()(startedAt).format("M월 D일"), " 훈련이 시작될 "),
                                                "예정입니다."
                                            ]
                                        }),
                                        !isSigned && dayjs_min_default()().isAfter(applyEndedAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2 text-sm font-normal leading-normal text-gray-500",
                                            children: "- 이미 지원한 경우 로그인하여 진행내역을 확인하세요."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (((ref21 = submitType[status]) === null || ref21 === void 0 ? void 0 : ref21.period) === "applying" || isWorker && dayjs_min_default()().isBetween(applyStartedAt, applyEndedAt, undefined, "[)")) && expiryTimestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassTimer_BasicTimer, {
                    expiryTimestamp: expiryTimestamp
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-y-2 lg:mt-5",
                    children: (ref22 = kdt/* AdditionalList */.jh[courseType]) === null || ref22 === void 0 ? void 0 : ref22.map(function(addition) {
                        var isOpen = openAddition === addition.id;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "cursor-pointer rounded-lg bg-gray-50 p-4",
                            onClick: function() {
                                return handleItemClick(addition.id);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex h-6 w-6 items-center justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: addition.icon,
                                                        alt: addition.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-sm font-bold",
                                                    children: [
                                                        addition.boldTitle,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ml-1 inline-block font-normal",
                                                            children: addition.title
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                            className: "".concat(isOpen ? "" : "rotate-180 transform", " w-4 text-gray-400")
                                        })
                                    ]
                                }),
                                isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-4 flex flex-col gap-y-2",
                                    children: [
                                        addition.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-semibold",
                                            children: addition.summary
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-semibold",
                                                    children: addition.boldDesc
                                                }),
                                                addition.desc
                                            ]
                                        }),
                                        addition.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm text-gray-500",
                                            children: addition.reference
                                        })
                                    ]
                                })
                            ]
                        }, addition.title);
                    })
                })
            ]
        })
    });
};
var levelMap = (/* unused pure expression or super */ null && ([
    "입문",
    "초급",
    "중급",
    "고급",
    "고급이상"
]));
/* harmony default export */ var components_CourseInfo = (CourseInfo);


/***/ }),

/***/ 27279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var _CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41972);
/* harmony import */ var _CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5__);








function CustomNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(className, " ").concat((_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().right_arrow)),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style),
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/svg/icon_openpath_arrow_right.svg",
            className: "hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
        })
    });
}
function CustomPrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(className, " ").concat((_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().left_arrow)),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style),
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/svg/icon_openpath_arrow_left.svg",
            className: "hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
        })
    });
}
var CarouselRender = function(param) {
    var imgList = param.imgList;
    var settings = {
        dots: true,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        touchMove: true,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomPrevArrow, {}),
        className: "openPathCarousel",
        // eslint-disable-next-line react/display-name
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                id: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().openPathDotContainer),
                children: dots
            });
        },
        // eslint-disable-next-line react/display-name
        customPaging: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    id: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().openPathDot)
                })
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, settings), {
        children: imgList.map(function(url, idx) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img_container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: url,
                    className: "h-auto w-full px-12"
                })
            }, "".concat(url, "_").concat(idx));
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselRender);


/***/ }),

/***/ 39949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67804);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var FAQPost = function(param) {
    var faq = param.faq, handler = param.handler, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    var onFAQOpenHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setIsOpen(!isOpen);
        if (handler) {
            handler();
        }
    }, [
        handler,
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "overflow-hidden rounded-lg border border-gray-200 bg-gray-50 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex cursor-pointer items-center px-4 py-3 lg:px-5 lg:py-4 ".concat(isOpen ? "border-b border-gray-200" : ""),
                onClick: onFAQOpenHandler,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex max-w-full flex-1 items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium lg:text-base ".concat(isOpen ? "" : "truncate"),
                            children: faq.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-auto pl-2",
                            children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronUpIcon */ .g8U, {
                                className: "h-auto w-5 shrink-0"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronDownIcon */ .v4q, {
                                className: "h-auto w-5 shrink-0"
                            })
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full bg-white px-4 py-4 lg:px-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-start",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "-mt-1 text-sm font-normal lg:text-base",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: faq.content
                                }
                            }),
                            faq.link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: faq.link.url,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "mt-4 block text-sm font-normal lg:text-base",
                                    rel: "noreferrer",
                                    children: faq.link.text
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var FAQAccordion = function(param) {
    var faqList = param.faqList, handler = param.handler, defaultOpenIdx = param.defaultOpenIdx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col space-y-2 lg:space-y-4",
            children: faqList === null || faqList === void 0 ? void 0 : faqList.map(function(faq, idx) {
                var defaultOpen = defaultOpenIdx === idx;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQPost, {
                    faq: faq,
                    defaultOpen: defaultOpen,
                    handler: handler
                }, faq.title);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQAccordion);


/***/ }),

/***/ 28777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useCountDown; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3751);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_timer_hook__WEBPACK_IMPORTED_MODULE_3__);




dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_1___default()));
var useCountDown = function(expiryTimestamp) {
    var ref = (0,react_timer_hook__WEBPACK_IMPORTED_MODULE_3__.useTimer)({
        expiryTimestamp: expiryTimestamp,
        onExpire: function() {
            return console.warn("onExpire called");
        }
    }), seconds = ref.seconds, minutes = ref.minutes, hours = ref.hours, days = ref.days, restart = ref.restart;
    var isLeftApplyDurationOneDays = days === 0;
    var isLeftApplyDurationThreeDays = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(expiryTimestamp).diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(), "d") < 3;
    var isLeftApplyDurationSevenDays = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(expiryTimestamp).diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(), "d") < 7;
    var format = dayjs__WEBPACK_IMPORTED_MODULE_0___default().duration({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    }).format(isLeftApplyDurationOneDays ? "H:m:ss" : "D:H:m").split(":");
    var timeUnit = isLeftApplyDurationOneDays ? [
        "시간",
        "분",
        "초"
    ] : [
        "일",
        "시간",
        "분"
    ];
    var fullFormat = dayjs__WEBPACK_IMPORTED_MODULE_0___default().duration({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    }).format("D:H:m:ss").split(":");
    var fullTimeUnit = [
        "일",
        "시간",
        "분",
        "초"
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        restart(expiryTimestamp);
    }, [
        expiryTimestamp
    ]);
    return {
        format: format,
        timeUnit: timeUnit,
        isLeftApplyDurationThreeDays: isLeftApplyDurationThreeDays,
        isLeftApplyDurationSevenDays: isLeftApplyDurationSevenDays,
        isLeftApplyDurationOneDays: isLeftApplyDurationOneDays,
        fullFormat: fullFormat,
        fullTimeUnit: fullTimeUnit
    };
};


/***/ }),

/***/ 93974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66261);
/* harmony import */ var _KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36833);
/* harmony import */ var _KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var GNBHeight = 64;
var navbarHeight = 48;
var ContentMarginTop = 40;
var KlassDetailNav = function(param) {
    var handler = param.handler, isFaq = param.isFaq, isCurriculum = param.isCurriculum, _isReview = param.isReview, isReview = _isReview === void 0 ? false : _isReview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("lecture-intro"), activeKey = ref[0], setActiveKey = ref[1];
    var onChangeKey = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(key) {
        return setActiveKey(key);
    }, []);
    var navList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var defaultNav = [
            {
                order: 1,
                label: "강의 소개",
                href: "#lecture-intro"
            }, 
        ];
        if (isCurriculum) {
            defaultNav.push({
                order: 2,
                label: "커리큘럼",
                href: "#curriculum"
            });
        }
        if (isReview) {
            defaultNav.push({
                order: 3,
                label: "수강후기",
                href: "#review"
            });
        }
        if (isFaq) {
            defaultNav.push({
                order: 4,
                label: "자주 묻는 질문",
                href: "#faq"
            });
        }
        return lodash__WEBPACK_IMPORTED_MODULE_1___default().sortBy(lodash__WEBPACK_IMPORTED_MODULE_1___default().uniqBy(defaultNav, "href"), "order");
    }, [
        isCurriculum,
        isFaq,
        isReview
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sticky z-20 mx-auto box-border max-w-screen-2xl border-b border-gray-200 bg-white ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().navContainer)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto max-w-7xl xl:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "flex overflow-x-auto whitespace-nowrap px-4 pt-3 lg:px-6 xl:px-0 ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().scrollNo)),
                children: navList.map(function(param) {
                    var label = param.label, href = param.href;
                    var key = href.slice(1);
                    var isActive = activeKey === key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "flex flex-col ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().navItem), " relative"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-base block cursor-pointer ".concat(isActive ? "".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isActiveNav), " pb-3 text-primary-normal") : "text-gray-500"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                                to: key,
                                spy: true,
                                smooth: true,
                                onClick: function() {
                                    if (handler) {
                                        handler();
                                    }
                                },
                                onSetActive: function() {
                                    onChangeKey(key);
                                },
                                offset: -(GNBHeight + navbarHeight + ContentMarginTop),
                                children: label
                            })
                        })
                    }, key);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KlassDetailNav);


/***/ }),

/***/ 12083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useViewItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7316);





// GA 향상된 전자상거래 - enhanced ecommerce
// GA4 전자상거래 - ecommerce
var useViewItem = function(course, courseId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPushed = ref[0], setIsPushed = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(course) || course.id !== courseId || isPushed) return;
        react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer({
            dataLayer: {
                ecommerce: null
            }
        });
        // GA4
        react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer({
            dataLayer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                event: "view_item",
                ecommerce: {
                    items: [
                        (0,utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_3__/* .convertToEcommerceItem */ .Gn)(course)
                    ]
                }
            }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
        });
        setIsPushed(true);
    }, [
        course,
        courseId,
        isPushed
    ]);
};


/***/ }),

/***/ 77750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCourseFaqList; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82332);
/* harmony import */ var _stores_courses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70957);




var useCourseFaqList = function(courseId) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.courses;
    }), isLoading = ref.isLoading, courseFAQList = ref.faqList;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(courseId)) {
            dispatch((0,_stores_courses__WEBPACK_IMPORTED_MODULE_3__/* .fetchCourseFAQListThunk */ .g_)(courseId));
        }
    }, [
        courseId,
        dispatch
    ]);
    return {
        isLoading: isLoading,
        courseFAQList: courseFAQList
    };
};


/***/ }),

/***/ 41972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"left_arrow":"CarouselRend_left_arrow___46VZ","right_arrow":"CarouselRend_right_arrow__GLUMP","img_container":"CarouselRend_img_container__UlePo","openPathDotContainer":"CarouselRend_openPathDotContainer__zeDn7","openPathDot":"CarouselRend_openPathDot__TYd0D"};

/***/ }),

/***/ 76973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"EarlyKlassTooltip_Tooltip__rbHjc","TooltipMotion":"EarlyKlassTooltip_TooltipMotion__dVEG3","motion":"EarlyKlassTooltip_motion__JlbAe","TooltipArrow":"EarlyKlassTooltip_TooltipArrow__1Yjuu"};

/***/ }),

/***/ 36833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollNo":"KlassDetailNav_scrollNo__UkYR0","navContainer":"KlassDetailNav_navContainer__bn8_o","navItem":"KlassDetailNav_navItem__XliVY","isActiveNav":"KlassDetailNav_isActiveNav__uefvi"};

/***/ })

}]);